export enum Claims {
  SCU = 'http://claims.pyracloud.com/SCU',
}
